// extracted by mini-css-extract-plugin
export default {"visuallyhidden":"access-policy-tiles__visuallyhidden--nPX_t","focusable":"access-policy-tiles__focusable--dfLWS","container":"access-policy-tiles__container--HzvMq"};